"use strict";

var _slicedToArray = require("/home/circleci/repo/web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var util_1 = require("./util");

var patchHistoryMethod = function patchHistoryMethod(method) {
  var original = history[method];

  history[method] = function (state) {
    var result = original.apply(this, arguments);
    var event = new Event(method.toLowerCase());
    event.state = state;
    window.dispatchEvent(event);
    return result;
  };
};

if (util_1.isClient) {
  patchHistoryMethod('pushState');
  patchHistoryMethod('replaceState');
}

var useLocation = function useLocation() {
  var buildState = function buildState(trigger) {
    var _history = history,
        state = _history.state,
        length = _history.length;
    var _location = location,
        hash = _location.hash,
        host = _location.host,
        hostname = _location.hostname,
        href = _location.href,
        origin = _location.origin,
        pathname = _location.pathname,
        port = _location.port,
        protocol = _location.protocol,
        search = _location.search;
    return {
      trigger: trigger,
      state: state,
      length: length,
      hash: hash,
      host: host,
      hostname: hostname,
      href: href,
      origin: origin,
      pathname: pathname,
      port: port,
      protocol: protocol,
      search: search
    };
  };

  var _react_1$useState = react_1.useState(util_1.isClient ? buildState('load') : {
    trigger: 'load',
    length: 1
  }),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      state = _react_1$useState2[0],
      setState = _react_1$useState2[1];

  var onChange = function onChange(trigger) {
    return setState(buildState(trigger));
  };

  var onPopstate = function onPopstate() {
    return onChange('popstate');
  };

  var onPushstate = function onPushstate() {
    return onChange('pushstate');
  };

  var onReplacestate = function onReplacestate() {
    return onChange('replacestate');
  };

  react_1.useEffect(function () {
    util_1.on(window, 'popstate', onPopstate);
    util_1.on(window, 'pushstate', onPushstate);
    util_1.on(window, 'replacestate', onReplacestate);
    return function () {
      util_1.off(window, 'popstate', onPopstate);
      util_1.off(window, 'pushstate', onPushstate);
      util_1.off(window, 'replacestate', onReplacestate);
    };
  }, [0]);
  return state;
};

exports.default = useLocation;